<template>
    <div class="c-receive-list">
        <table-tool-bar>
            <template slot="left">
                <Button
                    v-if="$can('update')"
                    :class="preCls + 'button-margin'"
                    :disabled="loading || isDisabled"
                    @click="onClickSetting"
                >
                    批量设置
                </Button>
            </template>
        </table-tool-bar>
        <!-- 列表-->
        <tree-table
            ref="mt"
            :columns="columns"
            :data="treeList"
            :loading="loading"
            :height="mtHeight"
            showCheckbox
            showExpandLevel
            multiple
            @on-check-change="checkChange"
            @on-toggle-expand="toggleExpand"
        >
            <template v-slot:wechatAttach="{ row }">
                <div style="display: flex; line-height: 42px">
                    <preview-upload
                        readonly
                        :value="row.wechatAttach"
                        :format="imgSuffix"
                    />
                    <span>{{ row.wechatRemark }}</span>
                </div>
            </template>
            <template v-slot:alipayAttach="{ row }">
                <div style="display: flex; line-height: 42px">
                    <preview-upload
                        readonly
                        :value="row.alipayAttach"
                        :format="imgSuffix"
                    />
                    <span>{{ row.alipayRemark }}</span>
                </div>
            </template>
            <template v-slot:action="{ row }">
                <Button
                    v-if="row.level === 4"
                    size="small"
                    style="margin-right: 5px"
                    @click="rowClickSetting(row)"
                >
                    设置
                </Button>
            </template>
        </tree-table>

        <!-- 弹出层 -->
        <smart-modal
            v-model="modal.showCollectForm"
            title="收款方式设置"
            :width="800"
            :height="600"
            :maskClosable="false"
            @close-by-confirm="fetch"
        >
            <c-receive-form
                v-if="modal.showCollectForm"
                :houseIds="houseIds"
                :offlinePayStatus="offlinePayStatus"
            />
        </smart-modal>

        <!-- 线下支付暂停使用通知 -->
        <smart-modal
            v-model="modal.suspensionNotice"
            ref="suspensionNotice"
            title="线下支付暂停使用通知"
            :width="400"
            :height="200"
            :maskClosable="false"
        >
            应监管要求，3月1日起平台将对个人收款码收款进行规范调整。即日起，不再支持线下支付，不便之处，敬请谅解。请转为线上支付，银行直连，资金安全，如需开通，请联系平台工作人员。
        </smart-modal>
    </div>
</template>

<script>
import config from '@/config'
import { currency, deepCopy, groupBy } from '_u/helper.js'

import { collectList, getOfflinePaySwitch } from '@/api/setting'

import CReceiveForm from './c-receive-form'

export default {
    name: 'c-receive-list',
    data() {
        return {
            loading: false,
            mtHeight: 360,
            houseIds: '',
            modal: {
                showCollectForm: false,
                suspensionNotice: false, // 暂停通知
            },
            dict: {},
            treeList: [],
            nodeList: [],
            imgSuffix: config.upload.imgSuffix,
            foldMap: [], //{id: "", expand: true}
            offlinePayStatus: '', //线下支付开关
        }
    },
    components: {
        CReceiveForm,
    },
    computed: {
        columns() {
            var list = []
            if (this.offlinePayStatus == 'off') {
                list = [
                    {
                        key: 'title',
                        minWidth: 200,
                        title: '房源',
                        align: 'left',
                        tree: true,
                    },
                    {
                        key: 'bankCardTypeText',
                        minWidth: 120,
                        title: '线上收款方式',
                        align: 'left',
                        tooltip: true,
                    },
                    {
                        key: 'bankCardFee',
                        minWidth: 120,
                        title: '线上手续费',
                        align: 'left',
                        tooltip: true,
                    },
                    {
                        key: 'action',
                        title: '操作',
                        align: 'center',
                        width: 100,
                        fixed: 'right',
                        slot: 'action',
                    },
                ]
            } else if (this.offlinePayStatus == 'on') {
                list = [
                    {
                        key: 'title',
                        minWidth: 200,
                        title: '房源',
                        align: 'left',
                        tree: true,
                    },
                    {
                        key: 'bankCardTypeText',
                        minWidth: 120,
                        title: '线上收款方式',
                        align: 'left',
                        tooltip: true,
                    },
                    {
                        key: 'bankCardFee',
                        minWidth: 120,
                        title: '线上手续费',
                        align: 'left',
                        tooltip: true,
                    },
                    {
                        key: 'wechatAttach',
                        minWidth: 200,
                        title: '微信二维码',
                        align: 'left',
                        tooltip: true,
                        slot: 'wechatAttach',
                    },
                    {
                        key: 'wechatFee',
                        minWidth: 120,
                        title: '微信手续费',
                        align: 'left',
                        tooltip: true,
                    },
                    {
                        key: 'alipayAttach',
                        minWidth: 200,
                        title: '支付宝二维码',
                        align: 'left',
                        tooltip: true,
                        slot: 'alipayAttach',
                    },
                    {
                        key: 'action',
                        title: '操作',
                        align: 'center',
                        width: 100,
                        fixed: 'right',
                        slot: 'action',
                    },
                ]
            }

            return list
        },
        // 有选中房间，显示批量设置
        isDisabled() {
            return this.nodeList.length === 0
        },
    },
    methods: {
        // 获取当前商户线下支付开关
        getPayStatus() {
            getOfflinePaySwitch().then((res) => {
                var status = res.data.data.switch
                this.offlinePayStatus = status
                console.log(status)
                if (status == 'off') {
                    this.onStopNotice()
                }
            })
        },
        fetch() {
            this.loading = true
            this.nodeList = []
            Promise.all([
                collectList(),
                this.$dict.get(['collect_type', 'collect_mode']),
            ])
                .then((args) => {
                    var [view, dictGroup] = args
                    Object.assign(this.dict, dictGroup)
                    this.setData(view.data.list)
                })

                .finally(() => (this.loading = false))
        },
        setData(list) {
            const treeList = []
            // 末极节点-先把末极节点筛选出来，做数据处理；然后合并到list里
            const treeNodeList = []
            Object.values(
                groupBy(
                    list.filter((v) => v.level === 4),
                    'id'
                )
            ).forEach((g) => {
                if (g.length) {
                    const bankCard = g.find((p) => p.collectType === '1') || {}
                    const wechat = g.find((p) => p.collectMode === '10') || {}
                    const alipay = g.find((p) => p.collectMode === '11') || {}

                    bankCard.collectModeText = treeNodeList.push({
                        expand: g[0].expand,
                        floorNum: g[0].floorNum,
                        id: g[0].id,
                        level: g[0].level,
                        nodeKey: g[0].nodeKey,
                        orderId: g[0].orderId,
                        pid: g[0].pid,
                        title: g[0].title,
                        bankCardTypeText:
                            this.dict.collectMode.val(bankCard.collectMode) ||
                            '',
                        bankCardFee: bankCard.serviceFee
                            ? currency(bankCard.serviceFee * 100) + '%'
                            : '无',
                        wechatAttach: wechat.attachments,
                        wechatRemark: wechat.remark,
                        wechatFee: wechat.serviceFee
                            ? currency(wechat.serviceFee * 100) + '%'
                            : '无',
                        alipayAttach: alipay.attachments,
                        alipayRemark: alipay.remark,
                    })
                }
            })
            list = list.filter((v) => v.level !== 4).concat(treeNodeList)
            list.forEach((v) => {
                const obj = this.foldMap.find((f) => f.id === v.id)
                v.expand = obj ? obj.expand : false
                if (v.level === 1) {
                    v.children = []
                    treeList.push(v)
                } else if (v.level === 2) {
                    const park = treeList.find((t) => t.id === v.pid)
                    if (park) {
                        v.children = []
                        park.children.push(v)
                    }
                } else if (v.level === 3) {
                    treeList.forEach((park) => {
                        const build = park.children.find((n) => n.id === v.pid)
                        if (build) {
                            v.children = []
                            build.children.push(v)
                        }
                    })
                } else if (v.level === 4) {
                    treeList.forEach((park) => {
                        park.children.forEach((build) => {
                            const floor = build.children.find(
                                (n) => n.id === v.pid
                            )
                            const dict = this.dict
                            if (floor) {
                                v.collectTypeText = dict.collectType.val(
                                    v.collectType
                                )
                                v.collectModeText = dict.collectMode.val(
                                    v.collectMode
                                )
                                v.hasFeeText = v.hasFee == 1 ? '是' : '否'
                                floor.children.push(v)
                            }
                        })
                    })
                }
            })
            this.treeList = treeList
        },

        rowClickSetting(row) {
            this.houseIds = row.id
            this.modal.showCollectForm = true
        },
        onClickSetting() {
            const houseIds = []
            this.nodeList.forEach((v) => houseIds.push(v.node.id))
            this.houseIds = houseIds.join(',')
            this.modal.showCollectForm = true
        },
        checkChange(nodes) {
            this.nodeList = nodes.filter((v) => v.data.level === 4)
        },
        toggleExpand(el) {
            let obj = this.foldMap.find((val) => val.id === el.data.id)
            if (obj) {
                obj.expand = el._isExpand
            } else {
                this.foldMap.push({ id: el.data.id, expand: el._isExpand })
            }
        },

        // 暂停通知
        onStopNotice() {
            this.modal.suspensionNotice = true

            var btns = [{ type: 'default', text: '知道了', name: 'cancel' }]
            this.$refs.suspensionNotice.updateBtns(btns)
        },
    },
    created() {
        this.fetch()
        this.getPayStatus()
    },
    mounted() {
        this.afterContainerResize((el, detector) => {
            this.mtHeight =
                detector.windowHeight -
                this.$refs.mt.$el.getBoundingClientRect().top -
                80
        })
    },
}
</script>

<style lang="less">
.c-receive-list {
    .ivu-preview-upload-item {
        width: 40px;
        height: 40px;
        margin-bottom: 0px;
        line-height: 42px;
    }
}
</style>
